import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isSalesForceInitialized } from '@mews-commander/chat';
import ChatTriggerButtonComponent from './ChatTriggerButtonComponent';

export const ChatTriggerButtonWrapper = connect(
    createStructuredSelector({
        isSalesForceChatInitialized: isSalesForceInitialized,
    })
)(ChatTriggerButtonComponent);
